<div class="inner-page-header">
  <h3>الشروط والأحكام</h3>
</div>

<form class="needs-validation" id="general-form" [formGroup]="termsConditionsFormGroup" (ngSubmit)="save()">
  <div class="main-card">

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="" class="form-label">
            عنوان الشروط والأحكام
          </label>
          <input type="text" class="form-control" formControlName="label" />
        </div>
      </div>

      <div class="col-md-12 mb-3" id="summernote_editor">
        <label class="form-label">التعريفات</label>
        <div formControlName="definitions" [ngxSummernote]="summerNoteConfig" class="custom-height"
          [class.ng-invalid]="submitted && termsConditionsFormGroup.get('definitions').invalid" 
          [class.ng-touched]="termsConditionsFormGroup.get('definitions').touched" 
          [class.submitted]="submitted"></div>
      </div>

      <div class="col-md-12 mb-3" id="summernote_editor">
        <label class="form-label">الشروط والأحكام</label>
        <div formControlName="terms_and_conditions" [ngxSummernote]="summerNoteConfig"  class="custom-height"
          [class.ng-invalid]="submitted && termsConditionsFormGroup.get('terms_and_conditions').invalid" 
          [class.ng-touched]="termsConditionsFormGroup.get('terms_and_conditions').touched" 
          [class.submitted]="submitted"></div>
      </div>
    </div>
    @if (alertmsg) {
    <div class="alert-box mb-0">
      <img src="assets/images/svg/error-icon.svg" class="close-alert" (click)="alertmsg=false" alt="" />
      <p class="alert-msg">{{ message }}</p>
    </div>
    }
  </div>
  <div class="action-btn-wrapper">
    <div class="double-action">
      <a class="btn btn-cancel" type="button" [routerLink]="['/pages/services/terms-conditions']">
        رجوع
      </a>
      <button class="btn btn-green" id="saveBtn" type="submit">
        حفظ
      </button>
    </div>
  </div>
</form>
